export default function AdminRedirect() {
  return (
    <div className="AdminRedirect" style={{ margin: '0 auto' }}>
      <div style={{ width: '550px' }}>
        <h1>Admin panels have moved</h1>
        <p>
          Admin panels located here were renamed to Tools and moved to{' '}
          <a href="https://dsn.adobe.com/tools">https://dsn.adobe.com/tools</a>.
        </p>
      </div>
    </div>
  );
}
